export default __webpack_public_path__ + "static/media/right-arrow.80e8e8cd.svg";